export default class Tag {
	constructor(tag) {
		this.tagId = tag.tagId ?? "";
		this.label = tag.label ?? "";
		this.tagType = tag.tagType ?? "";
		this.isHidden = tag.isHidden ?? false;
	}
}
